var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlightly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0.421875C17.3137 0.421875 20 3.10817 20 6.42188V14.4219C20 17.7356 17.3137 20.4219 14 20.4219H6C2.68629 20.4219 1.28855e-07 17.7356 0 14.4219V6.42188C1.28855e-07 3.10817 2.68629 0.421875 6 0.421875H14ZM14.8438 13.3203C12.1686 10.6457 7.83217 10.6463 5.15723 13.3213L6.3584 14.5225C8.36945 12.5114 11.6304 12.5117 13.6416 14.5225L14.8438 13.3203ZM6.72656 6.28516C6.3099 6.28516 5.95573 6.43099 5.66406 6.72266C5.3724 7.01432 5.22656 7.36849 5.22656 7.78516C5.22656 8.20182 5.3724 8.55599 5.66406 8.84766C5.95573 9.13932 6.3099 9.28516 6.72656 9.28516C7.14323 9.28516 7.4974 9.13932 7.78906 8.84766C8.08073 8.55599 8.22656 8.20182 8.22656 7.78516C8.22656 7.36849 8.08073 7.01432 7.78906 6.72266C7.4974 6.43099 7.14323 6.28516 6.72656 6.28516ZM13.7266 6.28516C13.3099 6.28516 12.9557 6.43099 12.6641 6.72266C12.3724 7.01432 12.2266 7.36849 12.2266 7.78516C12.2266 8.20182 12.3724 8.55599 12.6641 8.84766C12.9557 9.13932 13.3099 9.28516 13.7266 9.28516C14.1432 9.28516 14.4974 9.13932 14.7891 8.84766C15.0807 8.55599 15.2266 8.20182 15.2266 7.78516C15.2266 7.36849 15.0807 7.01432 14.7891 6.72266C14.4974 6.43099 14.1432 6.28516 13.7266 6.28516Z",
    fill: "#FD8F13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlightly);
export default __webpack_public_path__ + "static/media/slightly.0b9e82ba83b7ea8f9cf02e69c4044afe.svg";
export { ForwardRef as ReactComponent };